import { render, staticRenderFns } from "./addOfficer.vue?vue&type=template&id=e31a024c"
import script from "./addOfficer.vue?vue&type=script&lang=js"
export * from "./addOfficer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports